@if (user$ | async; as user) {
  @if (client$ | async; as client) {
    @if (diensten$ | async; as diensten) {
      @if (zones$ | async; as zones) {
        @if (taakTipAantallen$ | async; as taakTipAantallen) {
          <zah-client-header [client]="client"
            label="Diensten">
          </zah-client-header>
          <zah-client-diensten [user]="user"
            [client]="client"
            [diensten]="diensten"
            [zones]="zones"
            [taakTipAantallen]="taakTipAantallen"
            emptyLabel="Er zijn geen diensten en taken geselecteerd voor deze cliënt."
            (meldingenClicked)="navigateToMeldingen(client)"
            (prestatieClicked)="navigateToPrestaties(client)"
            (signaalkaartClicked)="navigateToSignaalkaarten(client)"
            (wijzigClientClicked)="navigateToClientWijzigen(client)"
            (clientFicheClicked)="navigateToClientFiche(user, client)"
            (tipsOpened)="navigateToTips(client, $event)">
            <button mat-mini-fab
              color="primary"
              class="back-button"
              (click)="navigateToClienten(user)">
              <mat-icon>arrow_back</mat-icon>
            </button>
          </zah-client-diensten>
        }
      }
    }
  }
}
